import {
  AppCollectionVisibility,
  isCollectionRemoved,
} from '@wix/wix-data-client-common-standalone'
import {
  getCollectionName,
  isDatasetConfigured,
  isDatasetConnectedToDbDriverCollection,
} from '../business-logic/datasets/datasetConfigHelper'
import {
  ROUTER_DATASET,
  DATASET,
  listAllControllers,
} from '@wix/wix-data-client-common'
import { getRouterDatasetConfig } from '../business-logic/datasets/routerDataset'

export const updateControllersState = async ({
  editorSdkProxy,
  collectionsApi,
  appApi,
  controllerRefsToUpdate = null,
}) => {
  const controllerRefsByState = await getConfiguredControllerRefsByState({
    editorSdkProxy,
    collectionsApi,
    appApi,
    controllerRefsToUpdate,
  })

  await editorSdkProxy.controllers.setState({
    state: controllerRefsByState,
  })
}

const getConfiguredControllerRefsByState = async function ({
  editorSdkProxy,
  collectionsApi,
  appApi,
  controllerRefsToUpdate,
}) {
  const [controllers, collections, appCollectionVisibility] = await Promise.all(
    [
      controllerRefsToUpdate
        ? Promise.resolve(
            controllerRefsToUpdate.map(controllerRef => ({ controllerRef })),
          )
        : listAllControllers(editorSdkProxy),
      collectionsApi
        .getAll({ includeHiddenAppCollections: true })
        .catch(() => []),
      appApi
        .getAppCollectionVisibility()
        .catch(() => AppCollectionVisibility.VISIBLE),
    ],
  )

  const controllerRefsAndConfigs = await Promise.all(
    controllers.map(async ({ controllerRef }) => {
      const { type, config } = await editorSdkProxy.controllers.getData({
        controllerRef,
      })
      return {
        controllerRef,
        type,
        config:
          type === DATASET
            ? config
            : await getRouterDatasetConfig(
                editorSdkProxy,
                controllerRef,
                config,
              ).catch(() => null),
      }
    }),
  )

  const controllersByState = controllerRefsAndConfigs.reduce(
    (controllersByState, { config, type, controllerRef }) => {
      if (appApi.isControllerHidden(controllerRef)) {
        controllersByState.hidden.push(controllerRef)
      } else if (config && isDatasetConfigured(config)) {
        if (isCollectionRemoved(collections, getCollectionName(config))) {
          controllersByState.connectedToDeletedCollection.push(controllerRef)
        } else if (
          appCollectionVisibility === AppCollectionVisibility.HIDDEN &&
          isDatasetConnectedToDbDriverCollection({ config, collections })
        ) {
          controllersByState.connectedToHiddenAppCollection.push(controllerRef)
        } else {
          controllersByState.configured.push(controllerRef)
        }
      } else if (type === ROUTER_DATASET) {
        controllersByState.brokenConfig.push(controllerRef)
      }
      return controllersByState
    },
    {
      configured: [],
      hidden: [],
      connectedToHiddenAppCollection: [],
      connectedToDeletedCollection: [],
      brokenConfig: [],
    },
  )

  return controllersByState
}
